import { CloudUpload32 } from '@carbon/icons-react';
import {
  Button,
  ComboBox,
  ComposedModal,
  DatePicker,
  DatePickerInput,
  Dropdown,
  InlineNotification,
  Loading,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TextInput,
} from 'carbon-components-react';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { assignErrorMessage, setLoadingValue, setMaterialListValue, setSubmitValue } from '../../actions/commonAction';
import {
  acceptOrder,
  cancelOrder,
  getAccountTitleList,
  getApproveStockOutUsers,
  getCategoryList,
  getEngineListByCompany,
  getMaterialList,
  getOrder,
  getOtherConsumerList,
  getTestStockOutUsers,
} from '../../services';
import { CurrencyFormatter, repairLevelList } from '../../constants';

class StockOutOrderTest extends Component {
  constructor(props) {
    super(props);
    const { auth } = this.props;
    this.state = {
      orderInfo: {
        id: '',
        orderName: '',
        status: '',
        requestor: '',
        requestNote: '',
        requestDate: '',
        tester: auth.userID,
        testNote: '',
        testDate: '',
        approver: '',
        supplier: '',
        no: '',
        co: '',
        recipeNo: '',
        recipeDate: '',
        deliver: '',
        attachedDocument: '',
        stockName: '',
        address: '',
        category: '',
        companyID: auth.companyID,
      },
      orderDetailList: [],
      testRecipe: {
        id: '',
        orderID: '',
        leader: '',
        leaderPosition: '',
        leaderRepresentation: '',
        firstCommissioner: '',
        firstCommissionerPosition: '',
        firstCommissionerRepresentation: '',
        secondCommissioner: '',
        secondCommissionerPosition: '',
        secondCommissionerRepresentation: '',
        comment: '',
      },
      testNoteErrorMessage: '',
      testerList: [],
      approverList: [],
      quantityErrorMessages: [],
      categoryList: [],
      otherConsumerList: [],
      engineList: [],
      accountList: [],
      testDateErrorMessage: '',
    };
  }

  componentDidMount = async () => {
    const { setErrorMessage, setLoading, location, auth, common, setMaterialList } = this.props;
    const params = new URLSearchParams(location.search);
    if (params == null) {
      setErrorMessage('Không có mã yêu cầu nhập kho!!!');
      return;
    }
    const orderID = params.get('orderID');
    setLoading(true);
    let { materialList } = common;
    try {
      const getStockOutOrderInfoResult = await getOrder(orderID);
      if (getStockOutOrderInfoResult.data.orderInfo.tester !== auth.userID) {
        setErrorMessage('Bạn không có quyền truy cập ');
        setLoading(false);
        return;
      }
      if (getStockOutOrderInfoResult.data.orderInfo.status !== 'created') {
        setErrorMessage('Yêu cầu đã bị huỷ hoặc đã hoàn thành. Vui lòng thử lại.');
        setLoading(false);
        return;
      }
      const getTesterListResult = await getTestStockOutUsers(auth.companyID, auth.userID);
      const getApproverListResult = await getApproveStockOutUsers(auth.companyID, auth.userID);
      const getCategoryListResult = await getCategoryList();
      const getAccountListResult = await getAccountTitleList();
      if (materialList.length === 0) {
        const getMaterialListResult = await getMaterialList();
        materialList = getMaterialListResult.data;
        setMaterialList(materialList);
      }
      const getOtherConsumerListResult = await getOtherConsumerList();
      const getEngineListResult = await getEngineListByCompany(auth.companyID);

      this.setState({
        testerList: getTesterListResult.data.map((e) => {
          return { id: e.userID, label: e.username };
        }),
        approverList: getApproverListResult.data.map((e) => {
          return { id: e.userID, label: e.username };
        }),
        categoryList: [
          { id: '', label: '' },
          ...getCategoryListResult.data.map((e) => {
            return { id: e.categoryID, label: e.categoryID.concat(' - ').concat(e.categoryName) };
          }),
        ],
        accountList: [
          { id: '', label: '' },
          ...getAccountListResult.data.map((e) => {
            return { id: e.accountID, label: e.accountTitle.concat(' - ').concat(e.accountName) };
          }),
        ],
        orderInfo: getStockOutOrderInfoResult.data.orderInfo,
        orderDetailList: getStockOutOrderInfoResult.data.orderDetailList.map((e) => {
          const selectedMaterial = materialList.find((item) => item.materialID === e.materialID);
          e.materialName = selectedMaterial.materialName;
          e.unit = selectedMaterial.unit;
          e.productCode = selectedMaterial.productCode;
          e.testQuantity = e.requestQuantity;
          e.testAmount = e.requestAmount;
          return e;
        }),
        testRecipe: getStockOutOrderInfoResult.data.testRecipe,
        quantityErrorMessages: Array(getStockOutOrderInfoResult.data.orderDetailList.length).fill('', 0, getStockOutOrderInfoResult.data.orderDetailList.length),
        otherConsumerList: [
          ...getOtherConsumerListResult.data.map((e) => {
            return { id: e.consumerID, label: e.consumerName };
          }),
        ],
        engineList: [
          ...getEngineListResult.data.map((e) => {
            return { id: e.engineID, label: e.engineID };
          }),
          { id: 'other', label: 'Đối tượng tiêu thụ khác' },
        ],
      });
      this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, testDate: this.formatDate(new Date()) } }));
    } catch {
      setErrorMessage('Mã yêu cầu nhập kho không tồn tại!!!');
    }
    setLoading(false);
  };

  acceptOrder = async () => {
    const { setErrorMessage, setLoading, setSubmitResult } = this.props;
    const { orderInfo, orderDetailList, quantityErrorMessages, testRecipe } = this.state;

    this.setState({
      testNoteErrorMessage: '',
      quantityErrorMessages: Array(orderDetailList.length).fill('', 0, orderDetailList.length),
    });
    setErrorMessage('');

    let hasError = false;

    if (orderInfo.testDate === '') {
      hasError = true;
      this.setState({ testDateErrorMessage: 'Ngày lãnh đạo phê duyệt không được bỏ trống' });
    }
    const testDateParts = orderInfo.testDate.split('/');
    if (testDateParts.length !== 3) {
      hasError = true;
      this.setState({ testDateErrorMessage: 'Ngày lãnh đạo phê duyệt không đúng định dạng' });
    }
    const requestDateParts = orderInfo.requestDate.split('/');
    const testDate = new Date(testDateParts[2], testDateParts[1] - 1, testDateParts[0]);
    const requestDate = new Date(requestDateParts[2], requestDateParts[1] - 1, requestDateParts[0]);

    if (testDate < requestDate) {
      hasError = true;
      this.setState({ testDateErrorMessage: 'Ngày lãnh đạo phê duyệt không được sau ngày tạo đơn' });
    }

    if (testDateParts[1] - 1 !== requestDateParts[1] - 1) {
      hasError = true;
      this.setState({ testDateErrorMessage: 'Ngày lãnh đạo phê duyệt phải trong kỳ (tháng) của ngày tạo' });
    }

    const currentDate = new Date();
    if (testDate > currentDate) {
      hasError = true;
      this.setState({ testDateErrorMessage: 'Ngày lãnh đạo phê duyệt không được vượt ngày hiện tại' });
    }

    // if (testDateParts[1] - 1 !== currentDate.getMonth()) {
    //   hasError = true;
    //   this.setState({ testDateErrorMessage: 'Ngày nghiệm thu phải trong kỳ (tháng)' });
    // }

    orderDetailList.forEach((e, index) => {
      if (e.testQuantity === '') {
        hasError = true;
        quantityErrorMessages[index] = 'Cần nhập vào số lượng';
      }
      // eslint-disable-next-line no-restricted-globals
      if ((e.testQuantity !== '' && isNaN(e.testQuantity)) || Number(e.testQuantity) < 0) {
        hasError = true;
        quantityErrorMessages[index] = 'Số lượng không hợp lệ';
      }
      if (e.requestQuantity !== e.testQuantity && orderInfo.testNote.trim() === '') {
        hasError = true;
        this.setState({ testNoteErrorMessage: 'Nội dung điều chỉnh không thể bỏ trống' });
      }
    });
    this.setState({ quantityErrorMessages });

    if (
      orderDetailList.length > 0 &&
      new Set(
        orderDetailList.map((e) => {
          return e.materialID;
        })
      ).size !== orderDetailList.length
    ) {
      hasError = true;
      setErrorMessage('Có mã vật tư bị trùng. Vui lòng kiểm tra lại');
    }
    if (hasError) {
      return;
    }

    orderInfo.status = 'tested';

    setLoading(true);
    try {
      await acceptOrder({ orderInfo, orderDetailList, testRecipe });
    } catch {
      setErrorMessage('Có lỗi khi lãnh đạo phê duyệt yêu cầu. Vui lòng thử lại.');
    }
    setSubmitResult('Yêu cầu được lãnh đạo phê duyệt thành công');
    setLoading(false);
  };

  cancelOrder = async () => {
    const { setErrorMessage, setLoading, setSubmitResult } = this.props;
    const { orderInfo } = this.state;
    if (orderInfo.testNote.trim() === '') {
      this.setState({ testNoteErrorMessage: 'Nội dung điều chỉnh không thể bỏ trống' });
      return;
    }
    orderInfo.status = 'cancelled';
    setLoading(true);
    try {
      await cancelOrder(orderInfo);
    } catch {
      setErrorMessage('Có lỗi khi huỷ yêu cầu. Vui lòng thử lại.');
    }
    setSubmitResult('Yêu cầu được huỷ thành công');
    setLoading(false);
  };

  formatDate = (inputDate) => {
    const yyyy = inputDate.getFullYear().toString();
    const mm = `0${inputDate.getMonth() + 1}`.slice(-2);
    const dd = `0${inputDate.getDate()}`.slice(-2);
    return `${dd}/${mm}/${yyyy}`;
  };

  render() {
    // Props first
    const { setErrorMessage, setSubmitResult, history, common } = this.props;
    const { submitResult, errorMessage, isLoading } = common;

    // Then state
    const {
      orderInfo,
      testerList,
      approverList,
      orderDetailList,
      quantityErrorMessages,
      categoryList,
      testRecipe,
      testNoteErrorMessage,
      otherConsumerList,
      engineList,
      accountList,
      testDateErrorMessage,
    } = this.state;

    const repairGroupList = [
      { id: 'Tổ Điện', label: 'Tổ Điện' },
      { id: 'Tổ Khung Gầm', label: 'Tổ Khung Gầm' },
      { id: 'Tổ Động cơ', label: 'Tổ Động cơ' },
      { id: 'Tổ Hãm', label: 'Tổ Hãm' },
      { id: 'Tổ Cơ khí', label: 'Tổ Cơ khí' },
      { id: 'Tổ Truyền động', label: 'Tổ Truyền động' },
      { id: 'Tổ Lâm tu ắc quy', label: 'Tổ Lâm tu ắc quy' },
    ];

    const qualityList = [
      { id: 'I', label: 'Loại I' },
      { id: 'II', label: 'Loại II' },
      { id: 'Phế liệu', label: 'Phế liệu' },
    ];

    return (
      <div className="stock-out-test">
        {/* Loading */}
        {isLoading && <Loading description="Loading data. Please wait..." withOverlay />}
        {/* Success Modal */}
        <ComposedModal
          className="btn-success"
          open={submitResult !== ''}
          size="sm"
          onClose={() => {
            setSubmitResult('');
            history.push('/home');
          }}
        >
          <ModalHeader iconDescription="Close" title={<div>Thao tác thành công</div>} />
          <ModalBody aria-label="Modal content">
            <div className="form-icon">
              <CloudUpload32 className="icon-prop" />
              <p className="bx--modal-content__text">{submitResult}</p>
            </div>
          </ModalBody>
          <ModalFooter
            onRequestSubmit={() => {
              setSubmitResult('');
              history.push('/home');
            }}
            primaryButtonText="OK"
            secondaryButtonText=""
          />
        </ComposedModal>
        {/* Error Message */}
        <div className="bx--grid">
          <div className="bx--row">
            {errorMessage !== '' && <InlineNotification lowContrast kind="error" title={errorMessage} onCloseButtonClick={() => setErrorMessage('')} />}
          </div>
        </div>
        <br />
        <div className="view-header--box">
          <h4>Yêu cầu xuất kho</h4>
        </div>
        <br />

        {/* Content page */}
        <div className="bx--grid">
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput id="orderName-TextInput" placeholder="Vui lòng nhập tên yêu cầu" labelText="Tên yêu cầu" value={orderInfo.orderName} disabled />
            </div>
            <div className="bx--col-lg-4">
              <TextInput id="requestNote-TextInput" placeholder="Vui lòng nhập lý do lập bảng" labelText="Lý do" value={orderInfo.requestNote} disabled />
            </div>
            <div className="bx--col-lg-4">
              <DatePicker datePickerType="single" dateFormat="d/m/Y" value={orderInfo.requestDate}>
                <DatePickerInput datePickerType="single" placeholder="dd/mm/yyyy" labelText="Ngày tạo yêu cầu" id="requestDate-datepicker" disabled />
              </DatePicker>
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <Dropdown
                id="tester-Dropdown"
                titleText="Phòng Kỹ thuật/Lãnh đạo phê duyệt cấp 1"
                label=""
                items={testerList}
                selectedItem={orderInfo.tester === '' ? null : testerList.find((e) => e.id === orderInfo.tester)}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <Dropdown
                id="approver-Dropdown"
                titleText="Phòng Kế toán Tài chính/Lãnh đạo phê duyệt cấp 2"
                label=""
                items={approverList}
                selectedItem={orderInfo.approver === '' ? null : approverList.find((e) => e.id === orderInfo.approver)}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <strong>Lưu ý:</strong>
              <br />
              <br /> - Với đơn xuất có giá trị &gt; 50M cần có PGĐ phê duyệt cấp 2
              <br />
              <br /> - Với đơn xuất có giá trị &gt; 100M cần có GĐ phê duyệt cấp 2
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput id="stockName-TextInput" placeholder="" labelText="Xuất tại kho (ngăn lô)" value={orderInfo.stockName} disabled />
            </div>
            <div className="bx--col-lg-4">
              <TextInput id="address-TextInput" placeholder="" labelText="Địa chỉ kho" value={orderInfo.address} disabled />
            </div>
            <div className="bx--col-lg-4">
              <TextInput id="attachedDocument-TextInput" placeholder="" labelText="Số chứng từ gốc kèm theo" value={orderInfo.attachedDocument} disabled />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <Dropdown
                id="repairLevel-Dropdown"
                titleText="Cấp sửa chữa"
                label=""
                items={repairLevelList}
                selectedItem={orderInfo.repairLevel === '' ? null : repairLevelList.find((e) => e.id === orderInfo.repairLevel)}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <Dropdown
                id="repairGroup-Dropdown"
                titleText="Tổ sửa chữa"
                label=""
                items={repairGroupList}
                selectedItem={orderInfo.repairGroup === '' ? null : repairGroupList.find((e) => e.id === orderInfo.repairGroup)}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput id="deliver-TextInput" placeholder="" labelText="Địa chỉ (bộ phận)" value={orderInfo.deliver} disabled />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <ComboBox
                id="no-ComboBox"
                titleText="Nợ"
                placeholder=""
                label=""
                items={categoryList}
                selectedItem={orderInfo.no === '' ? null : categoryList.find((e) => e.id === orderInfo.no)}
                onChange={(e) => this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, no: e.selectedItem == null ? '' : e.selectedItem.id } }))}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <ComboBox
                id="co-ComboBox"
                titleText="Có"
                placeholder=""
                label=""
                items={categoryList}
                selectedItem={orderInfo.co === '' ? null : categoryList.find((e) => e.id === orderInfo.co)}
                onChange={(e) => this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, co: e.selectedItem == null ? '' : e.selectedItem.id } }))}
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <ComboBox
                id="category-ComboBox"
                titleText="Khoản mục"
                placeholder=""
                label=""
                items={accountList}
                selectedItem={orderInfo.category === '' ? null : accountList.find((e) => e.id === orderInfo.category)}
                onChange={(e) =>
                  this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, category: e.selectedItem == null ? '' : e.selectedItem.id } }))
                }
                disabled
              />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <Dropdown
                id="engineID-Dropdown"
                titleText="Đầu máy tiêu thụ"
                label=""
                items={engineList}
                selectedItem={
                  engineList.find((e) => e.id === orderInfo.consumer) == null
                    ? { id: 'other', label: 'Khác' }
                    : engineList.find((e) => e.id === orderInfo.consumer)
                }
                disabled
              />
            </div>
            <div className="bx--col-lg-4">
              <ComboBox
                id="otherConsumer-ComboBox"
                titleText="Đối tượng chi phí khác"
                placeholder=""
                label=""
                items={otherConsumerList}
                selectedItem={otherConsumerList.find((e) => e.id === orderInfo.consumer)}
                onChange={(e) =>
                  this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, consumer: e.selectedItem == null ? '' : e.selectedItem.id } }))
                }
                disabled
              />
            </div>
          </div>
          <br />
          <hr className="LeftNav-module--divider--1Z49I" />
        </div>
        <div className="bx--grid">
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput
                id="leader-TextInput"
                placeholder="Trưởng ban kiểm nghiệm"
                labelText="Trưởng ban"
                value={testRecipe.leader}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, leader: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="leaderPosition-TextInput"
                placeholder="Chức vụ trưởng ban kiểm nghiệm"
                labelText="Chức vụ"
                value={testRecipe.leaderPosition}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, leaderPosition: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="leaderRepresentation-TextInput"
                placeholder="Đại diện trưởng ban kiểm nghiệm"
                labelText="Đại diện"
                value={testRecipe.leaderRepresentation}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, leaderRepresentation: e.target.value } }))}
              />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput
                id="firstCommissioner-TextInput"
                placeholder="Uỷ viên ban kiểm nghiệm"
                labelText="Uỷ viên"
                value={testRecipe.firstCommissioner}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, firstCommissioner: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="firstCommissionerPosition-TextInput"
                placeholder="Chức vụ"
                labelText="Chức vụ"
                value={testRecipe.firstCommissionerPosition}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, firstCommissionerPosition: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="firstCommissionerRepresentation-TextInput"
                placeholder="Đại diện"
                labelText="Đại diện"
                value={testRecipe.firstCommissionerRepresentation}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, firstCommissionerRepresentation: e.target.value } }))}
              />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput
                id="secondCommissioner-TextInput"
                placeholder="Uỷ viên ban kiểm nghiệm"
                labelText="Uỷ viên"
                value={testRecipe.secondCommissioner}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, secondCommissioner: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="secondCommissionerPosition-TextInput"
                placeholder="Chức vụ"
                labelText="Chức vụ"
                value={testRecipe.secondCommissionerPosition}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, secondCommissionerPosition: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <TextInput
                id="secondCommissionerRepresentation-TextInput"
                placeholder="Đại diện"
                labelText="Đại diện"
                value={testRecipe.secondCommissionerRepresentation}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, secondCommissionerRepresentation: e.target.value } }))}
              />
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput
                id="comment-TextInput"
                placeholder=""
                labelText="Ý kiến ban kiểm nghiệm"
                value={testRecipe.comment}
                onChange={(e) => this.setState((prevState) => ({ testRecipe: { ...prevState.testRecipe, comment: e.target.value } }))}
              />
            </div>
            <div className="bx--col-lg-4">
              <DatePicker
                datePickerType="single"
                dateFormat="d/m/Y"
                onChange={(e) =>
                  this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, testDate: this.formatDate(e[0]) }, testDateErrorMessage: '' }))
                }
                value={orderInfo.testDate}
              >
                <DatePickerInput
                  datePickerType="single"
                  placeholder="dd/mm/yyyy"
                  labelText="Ngày lãnh đạo phê duyệt"
                  id="testDate-datepicker"
                  invalid={testDateErrorMessage !== ''}
                  invalidText={testDateErrorMessage}
                />
              </DatePicker>
            </div>
            <div className="bx--col-lg-4">
              <Button onClick={() => this.acceptOrder()} style={{ marginTop: '1rem' }} disabled={orderInfo.status !== 'created'}>
                Nghiệm thu
              </Button>
            </div>
          </div>
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-4">
              <TextInput
                id="testNote-TextInput"
                placeholder=""
                labelText="Nội dung điều chỉnh"
                value={orderInfo.testNote}
                onChange={(e) => this.setState((prevState) => ({ orderInfo: { ...prevState.orderInfo, testNote: e.target.value }, testNoteErrorMessage: '' }))}
                invalid={testNoteErrorMessage !== ''}
                invalidText={testNoteErrorMessage}
              />
            </div>
            <div className="bx--col-lg-4" style={{ marginTop: '1rem' }}>
              <strong>Chú ý:</strong>
              <br />
              <ul>
                <li> - Nếu cần điều chỉnh, vui lòng nhập lý do điều chỉnh.</li>
                <li> - Nếu phải huỷ bỏ yêu cầu, vui lòng nhập lý do trong phần điều chỉnh.</li>
              </ul>
            </div>
            <div className="bx--col-lg-4">
              <Button onClick={() => this.cancelOrder()} style={{ marginTop: '1rem', backgroundColor: '#da1e28' }} disabled={orderInfo.status !== 'created'}>
                Huỷ yêu cầu
              </Button>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="bx--grid">
          <hr className="LeftNav-module--divider--1Z49I" />
          <br />
          <div className="bx--row">
            <div className="bx--col-lg-2 bx--col-md-2" />
            <div className="bx--col-lg-12">
              <TableContainer title="Chi tiết danh mục xuất kho">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeader key="stt">STT</TableHeader>
                      <TableHeader key="materialID">Mã vật tư</TableHeader>
                      <TableHeader key="productCode">Mã nhà sản xuất</TableHeader>
                      <TableHeader key="materialName">Tên vật tư</TableHeader>
                      <TableHeader key="unit">Đơn vị</TableHeader>
                      <TableHeader key="engineList">Đầu máy</TableHeader>
                      <TableHeader key="quality" style={{ width: '10%' }}>
                        Phân loại
                      </TableHeader>
                      <TableHeader key="quantity">Số lượng</TableHeader>
                      <TableHeader key="amount">Thành tiền</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {orderDetailList.map((row, index) => (
                      <TableRow key={`row-${index.toString()}`}>
                        <TableCell key={`stt-${index.toString()}`}>{index + 1}</TableCell>
                        <TableCell key={`materialID-${index.toString()}`}>{orderDetailList[index].materialID}</TableCell>
                        <TableCell key={`productCode-${index.toString()}`}>{orderDetailList[index].productCode}</TableCell>
                        <TableCell key={`materialName-${index.toString()}`}>{orderDetailList[index].materialName}</TableCell>
                        <TableCell key={`unit-${index.toString()}`}>{orderDetailList[index].unit}</TableCell>
                        <TableCell key={`engineList-${index.toString()}`}>{orderDetailList[index].engineList}</TableCell>
                        <TableCell key={`quality-${index.toString()}`}>
                          <Dropdown
                            id={`quality-Dropdown-${index}`}
                            titleText=""
                            label=""
                            items={qualityList}
                            selectedItem={orderDetailList[index].quality === '' ? null : qualityList.find((e) => e.id === orderDetailList[index].quality)}
                            onChange={(e) => {
                              orderDetailList[index].quality = e.selectedItem.id;
                              this.setState({ orderDetailList });
                            }}
                            disabled
                          />
                        </TableCell>
                        <TableCell key={`quantity-${index.toString()}`}>
                          <TextInput
                            id={`quantity-textinput-${index}`}
                            labelText=""
                            onChange={(e) => {
                              orderDetailList[index].testQuantity = e.target.value;
                              quantityErrorMessages[index] = '';
                              this.setState({ orderDetailList, quantityErrorMessages });
                            }}
                            value={orderDetailList[index].testQuantity}
                            invalid={quantityErrorMessages[index] !== ''}
                            invalidText={quantityErrorMessages[index]}
                          />
                        </TableCell>
                        <TableCell key={`amount-${index.toString()}`}>{CurrencyFormatter.format(orderDetailList[index].testAmount)}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                    <TableRow />
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className="bx--col-lg-2 bx--col-md-2" />
          </div>
        </div>
      </div>
    );
  }
}

StockOutOrderTest.propTypes = {
  setErrorMessage: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  setSubmitResult: PropTypes.func.isRequired,
  setMaterialList: PropTypes.func.isRequired,
  common: PropTypes.shape({
    submitResult: PropTypes.string,
    errorMessage: PropTypes.string,
    isLoading: PropTypes.bool,
    materialList: PropTypes.arrayOf(
      PropTypes.shape({
        materialID: PropTypes.string.isRequired,
        materialName: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,

  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool,
    userID: PropTypes.string,
    username: PropTypes.string,
    role: PropTypes.string,
    roleName: PropTypes.string,
    address: PropTypes.string,
    isActive: PropTypes.bool,
    companyID: PropTypes.string,
    companyName: PropTypes.string,
  }).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  common: state.common,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  setErrorMessage: (errorMessage) => dispatch(assignErrorMessage(errorMessage)),
  setLoading: (loading) => dispatch(setLoadingValue(loading)),
  setSubmitResult: (submitResult) => dispatch(setSubmitValue(submitResult)),
  setMaterialList: (materialList) => dispatch(setMaterialListValue(materialList)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StockOutOrderTest);
